import React from "react";

const ExamNavigation = ({
  current,
  currentMQ,
  questionsMQ,
  isCurrentQuestionMQ,
  isDisabledBack,
  isDisabledNext,
  handleNav,
  examData,
  assessmentId,
  handleSubmit,
  setShowInfoPanel,
  showInfoPanel,
  correctAnswers = {}, // Thêm prop correctAnswers
}) => {
  // Hàm lấy trạng thái của câu hỏi
  const getQuestionStatus = (questionNumber) => {
    const questionKey = `Câu ${questionNumber}`;
    if (correctAnswers.hasOwnProperty(questionKey)) {
      return correctAnswers[questionKey] ? "correct" : "incorrect";
    }
    return "unanswered";
  };

  // Hàm render status icon
  const renderStatusIcon = (status) => {
    switch (status) {
      case "correct":
        return <span className="text-green-500 font-bold">✓ Đúng</span>;
      case "incorrect":
        return <span className="text-red-500 font-bold">✗ Sai</span>;
      default:
        return <span className="text-gray-400">○ Chưa chấm</span>;
    }
  };

  // Kiểm tra xem câu hiện tại có phải MQ không
  const currentQuestionNumber = current + 1; // current là index 0-based
  const currentMQGroup = questionsMQ?.find(
    (group) => group.range && group.range.includes(currentQuestionNumber)
  );
  const isCurrentMQ = !!currentMQGroup; // Boolean thực sự

  // Hàm lấy range câu hỏi MQ và trạng thái của chúng
  const getMQRangeStatus = () => {
    if (!isCurrentMQ || !currentMQGroup) {
      return null;
    }

    const range = currentMQGroup.range || [];
    return range.map((questionNumber) => ({
      number: questionNumber,
      status: getQuestionStatus(questionNumber),
    }));
  };

  // Lấy trạng thái câu hiện tại (chỉ cho câu không phải MQ)
  const currentStatus = isCurrentMQ ? null : getQuestionStatus(current + 1);
  const mqRangeStatus = getMQRangeStatus();
  // Component hiển thị trạng thái range MQ
  const renderMQRangeStatus = () => {
    if (!mqRangeStatus || mqRangeStatus.length === 0) {
      return null;
    }

    return (
      <div className="flex flex-wrap items-center gap-1">
        <span className="text-base font-medium">
          Câu {mqRangeStatus[0].number}-
          {mqRangeStatus[mqRangeStatus.length - 1].number}:
        </span>
        <div className="flex items-center gap-1">
          {mqRangeStatus.map((question, index) => (
            <div key={question.number} className="flex items-center">
              <span className="text-base">{question.number}:</span>
              <span className="text-base ml-1">
                {question.status === "correct" ? (
                  <span className="text-green-500 font-bold">✓</span>
                ) : question.status === "incorrect" ? (
                  <span className="text-red-500 font-bold">✗</span>
                ) : (
                  <span className="text-gray-400">○</span>
                )}
              </span>
              {index < mqRangeStatus.length - 1 && (
                <span className="text-gray-400 mx-1">|</span>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="mt-5 bg-white rounded-lg text-black shadow-md">
      {/* Mobile Layout (sm và nhỏ hơn) */}
      <div className="block sm:hidden px-3 py-3 space-y-3">
        {/* Row 1: Navigation buttons */}
        <div className="flex justify-between items-center">
          <button
            className={`flex items-center gap-1 px-3 py-2 text-sm ${
              isDisabledBack
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-[#1c3664] text-white hover:opacity-90"
            } rounded-md font-medium transition-colors`}
            disabled={isDisabledBack}
            onClick={() => handleNav(current, false)}
          >
            <span>‹ Câu trước</span>
            <span className="hidden xs:inline">Trước</span>
          </button>

          <button
            className={`flex items-center gap-1 px-3 py-2 text-sm ${
              isDisabledNext
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-[#1c3664] text-white hover:opacity-90"
            } rounded-md font-medium transition-colors`}
            disabled={isDisabledNext}
            onClick={() => handleNav(current, true)}
          >
            <span className="hidden xs:inline">Tiếp</span>
            <span>Câu tiếp ›</span>
          </button>
        </div>

        {/* Row 2: Question status display */}
        {/* <div className="flex justify-center items-center text-center">
          <div className="flex items-center gap-1 px-2 py-1 bg-gray-50 rounded text-xs">
            {isCurrentMQ ? (
              renderMQRangeStatus()
            ) : (
              <div className="flex items-center gap-1">
                <span>Câu {current + 1}:</span>
                {renderStatusIcon(currentStatus)}
              </div>
            )}
          </div>
        </div> */}

        {/* Row 3: Submit button */}
        <div className="flex justify-center">
          <button
            className="flex items-center gap-2 px-4 py-2 bg-[#dc2626] text-white rounded-md font-medium hover:bg-[#b91c1c] transition-colors text-sm"
            onClick={() => setShowInfoPanel(!showInfoPanel)}
          >
            <span>Menu / Nộp bài</span>
          </button>
        </div>
      </div>

      {/* Tablet Layout (sm đến md) */}
      <div className="hidden sm:block md:hidden px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left: Back button */}
          <div className="flex-shrink-0">
            <button
              className={`flex items-center gap-2 px-3 py-2 text-sm ${
                isDisabledBack
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-[#1c3664] text-white hover:opacity-90"
              } rounded-md font-medium transition-colors`}
              disabled={isDisabledBack}
              onClick={() => handleNav(current, false)}
            >
              <span>‹</span>
              <span>Câu trước</span>
            </button>
          </div>

          {/* Center: Question status display */}
          {/* <div className="flex items-center gap-1 px-2 py-1 bg-gray-50 rounded text-sm">
            {isCurrentMQ ? (
              renderMQRangeStatus()
            ) : (
              <div className="flex items-center gap-1">
                <span>Câu {current + 1}:</span>
                {renderStatusIcon(currentStatus)}
              </div>
            )}
          </div> */}

          {/* Right: Next and Submit buttons */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              className={`flex items-center gap-2 px-3 py-2 text-sm ${
                isDisabledNext
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-[#1c3664] text-white hover:opacity-90"
              } rounded-md font-medium transition-colors`}
              disabled={isDisabledNext}
              onClick={() => handleNav(current, true)}
            >
              <span>Câu tiếp</span>
              <span>›</span>
            </button>

            <button
              className="flex items-center gap-1 px-3 py-2 bg-[#dc2626] text-white rounded-md font-medium hover:bg-[#b91c1c] transition-colors text-sm"
              onClick={() => setShowInfoPanel(!showInfoPanel)}
            >
              <span>Menu</span>
            </button>
          </div>
        </div>
      </div>

      {/* Desktop Layout (md và lớn hơn) */}
      <div className="hidden md:flex items-center justify-between px-4 py-3">
        {/* Left: Back button */}
        <div className="flex items-center gap-4">
          <button
            className={`flex items-center gap-2 px-4 py-2 ${
              isDisabledBack
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-[#1c3664] text-white hover:opacity-90"
            } rounded-md font-medium transition-colors`}
            disabled={isDisabledBack}
            onClick={() => handleNav(current, false)}
          >
            <span>‹</span>
            <span>Câu trước</span>
          </button>
        </div>

        {/* Center: Question status display */}
        {/* <div className="flex items-center gap-1 px-3 py-1 bg-gray-50 rounded">
          {isCurrentMQ ? (
            renderMQRangeStatus()
          ) : (
            <>
              <span>Câu {current + 1}:</span>
              {renderStatusIcon(currentStatus)}
            </>
          )}
        </div> */}

        {/* Right: Time left, Next and Submit buttons */}
        <div className="flex items-center gap-4">
          <button
            className={`flex items-center gap-2 px-4 py-2 ${
              isDisabledNext
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-[#1c3664] text-white hover:opacity-90"
            } rounded-md font-medium transition-colors`}
            disabled={isDisabledNext}
            onClick={() => handleNav(current, true)}
          >
            <span>Câu tiếp</span>
            <span>›</span>
          </button>

          <button
            className="flex items-center gap-2 px-4 py-2 bg-[#dc2626] text-white rounded-md font-medium hover:bg-[#b91c1c] transition-colors"
            onClick={() => setShowInfoPanel(!showInfoPanel)}
          >
            <span>‹ Mở menu / Nộp bài</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamNavigation;
